import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetSelectedStruttura } from '../services/storage-data.utility';

@Injectable({
  providedIn: 'root',
})
export class SelectedStrutturaInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const selectedStruttura = GetSelectedStruttura();
    const strutturaId = selectedStruttura ? selectedStruttura.id : null;

    if (strutturaId) {
      request = request.clone({
        setHeaders: {
          IdStructureOperation: `${strutturaId}`,
        },
      });
    }

    return next.handle(request);
  }
}
